<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5EDc0r/tc-custom/9783956768101.jpg?1704761785050" alt="This image is the cover for the book Tom, The Bootblack, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tom, The Bootblack, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Tom is a fifteen year old boy who lives in New York City with an old man named Jacob in Mrs. Flanagan’s rooming house. They pose as grandfather and grandson, but, while Tom understands that they are no real relation, he knows nothing about his real family. Tom makes a living for them both as a street bootblack. Just before Jacob dies, he tells the boy that he is really Gilbert Grey, the son of a wealthy Cincinnati, OH, businessman named John Grey. However, John’s brother James conspired with Jacob to spirit the child away, claiming that he drowned, so that James could inherit the family wealth. Jacob has written a confession explaining all the details. So after Jacob’s death, Tom, or Gilbert, heads for Cincinnati to see if he can locate his uncle and claim his fortune...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jr. Horatio Alger
      </h2>
      
      <p class="authorDescription body article">Horatio Alger Jr. ; January 13, 1832 – July 18, 1899) was a prolific 19th-century American writer, best known for his many young adult novels about impoverished boys and their rise from humble backgrounds to lives of middle-class security and comfort through hard work, determination, courage, and honesty. (Excerpt from Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f9d83744